module.exports = __webpack_public_path__ + "static/media/persona-3.1daa50c8.png";